import _ from 'lodash';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import { useTheme } from 'styled-components';

import * as graphql from '@treams/treams-network';

import { LineChartGradient } from '../../metrics/AnalyticsGraphMetric';
import DashboardCard from '../DashboardCard';
import DoughnutMetric from './DoughnutMetric';

export default function OverallScoreMetric(props: { data: graphql.AnalyticsEngagementScore }) {
	const { t } = useTranslation();
	const theme = useTheme();

	const points = props.data.datapoints.filter(
		(datapoint): datapoint is typeof datapoint & { score: number } =>
			typeof datapoint.score === 'number',
	);
	const meanScore = points.length > 0 ? _.mean(points.map((point) => point.score)) : 0;

	return (
		<DashboardCard
			title={t('dashboard.metrics.engagement.overallScore.title')}
			description={t('dashboard.metrics.engagement.overallScore.description')}
		>
			<Flex flexDirection="row" px={2} py={1}>
				{points.length === 0 ? (
					<DoughnutMetric.Skeleton animated={false} padding={0} />
				) : (
					<DoughnutMetric
						data={[
							{
								value: meanScore,
								color: 'employee',
							},
							{
								value: 10.0 - meanScore,
								color: 'employee',
								hidden: true,
							},
						]}
						digits={1}
						legend={false}
						tooltip={false}
						padding={0}
					/>
				)}
				<Box flexGrow={1} p={3} ml={2}>
					<LineChartGradient
						labels={points.map((point) => moment(point.timestamp).format('DD MMM'))}
						data={points.map((point) => ({
							x: new Date(point.timestamp).getTime(),
							y: point.score,
						}))}
						height={165}
						tintColor={theme.colors.employee}
						autoBound
						bounds={[1, 10]}
						yFormat={(y) => {
							return y.toFixed(1);
						}}
					/>
				</Box>
			</Flex>
		</DashboardCard>
	);
}
